export const ChkIconToastClose = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    data-testid="close-toast-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0104 1.01066C13.2057 0.8154 13.2057 0.498817 13.0104 0.303555C12.8151 0.108293 12.4986 0.108293 12.3033 0.303555L6.99987 5.60698L1.69669 0.303812C1.50143 0.10855 1.18485 0.108548 0.989588 0.30381C0.794326 0.499072 0.794326 0.815655 0.989588 1.01092L6.29276 6.31409L0.989586 11.6173C0.794324 11.8125 0.794324 12.1291 0.989586 12.3244C1.18485 12.5196 1.50143 12.5196 1.69669 12.3244L6.99987 7.0212L12.3033 12.3246C12.4986 12.5199 12.8151 12.5199 13.0104 12.3246C13.2057 12.1294 13.2057 11.8128 13.0104 11.6175L7.70697 6.31409L13.0104 1.01066Z"
      fill="currentColor"
    />
  </svg>
);
